var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4093 23.6629L31.5824 17.4898C31.9231 17.1491 31.9231 16.5962 31.5824 16.2555C31.2418 15.9148 30.6888 15.9148 30.3481 16.2555L24.175 22.4286L18.1661 16.4196C17.8254 16.079 17.2725 16.079 16.9318 16.4196C16.5912 16.7603 16.5912 17.3133 16.9318 17.6539L22.9408 23.6629L16.7711 29.8325C16.4305 30.1732 16.4305 30.7261 16.7711 31.0668C17.1118 31.4075 17.6647 31.4075 18.0054 31.0668L24.175 24.8971L30.5088 31.2309C30.8495 31.5716 31.4025 31.5716 31.7431 31.2309C32.0838 30.8903 32.0838 30.3373 31.7431 29.9967L25.4093 23.6629Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBlack);
export default __webpack_public_path__ + "static/media/cancel-black.09643c25e9f7c0a480f4755a12765de1.svg";
export { ForwardRef as ReactComponent };